import clx from 'classnames'
import { Modal } from 'antd'
import styles from './Modal.css'

const CustomizedModal = props => {
  const { children, className, visible, ...restProps } = props
  return (
    <Modal
      className={clx(styles.modal, className)}
      open={visible}
      {...restProps}
    >
      {children}
    </Modal>
  )
}

export default CustomizedModal
